"use client";

import { useQuery } from "@tanstack/react-query";
import { usePublicClient } from "wagmi";
import { WrapperABI } from "@/contract/abi/wrapper";
import ContractAddress from "@/contract/addresses";

export const useFetchWrapTokenList = (
  wrapperTokenIds: readonly bigint[] | undefined,
) => {
  const publicClient = usePublicClient();

  return useQuery({
    queryKey: ["wrapTokenList", wrapperTokenIds?.map((id) => id.toString())],
    queryFn: async () => {
      if (!wrapperTokenIds?.length || !publicClient) {
        return [];
      }

      const results = await Promise.all(
        wrapperTokenIds.map(async (wrapperTokenId) => {
          try {
            const wrapTokenInfo = await publicClient.readContract({
              address: ContractAddress.WRAPPER,
              abi: WrapperABI,
              functionName: "wrapTokenList",
              args: [wrapperTokenId],
            });

            // wrapTokenList returns [collection_address, token_id, plan_type, burned]
            const [collection_address, token_id, plan_type, burned] =
              wrapTokenInfo as [`0x${string}`, bigint, number, boolean];

            return {
              id: wrapperTokenId,
              plan: plan_type,
              original_id: token_id,
              collection_address,
              burned,
            };
          } catch (error) {
            console.error(
              `Error fetching wrapTokenList for token ${wrapperTokenId}:`,
              error,
            );
            return null;
          }
        }),
      );

      return results.filter(
        (result): result is NonNullable<typeof result> => result !== null,
      );
    },
    enabled: !!wrapperTokenIds?.length && !!publicClient,
  });
};
